export const NotificationTypes = {
  ENROLLMENT_DIGEST: 'ENROLLMENT_DIGEST',
  ISSUE_NOTIFICATION: 'ISSUE_NOTIFICATION',
  AI_BASED_ENROLLMENT_DIGEST: 'AI_BASED_ENROLLMENT_DIGEST'
};
export const NotificationCadences = {
  WEEKLY: 'WEEKLY',
  DAILY: 'DAILY'
};